import { Herolist } from "../heros/Herolist"


export const MarvelScreen = () => {
  return (
    <>
        <div>
            <Herolist publisher="Marvel Comics"/>
        </div>
    </>
  )
}
